/* eslint-disable */
import axios from '../index'

const insert = (data) => {
  return axios.post('vacancy', data)
}

const api = { insert }


export default api;